export default "__VITE_ASSET__DUeTigXG__"